module.exports = __webpack_public_path__ + "static/media/leocatering.1e915e07.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/leocatering.webp
// module id = 473
// module chunks = 0